// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"bm","header":"bn","overTitle":"bo","image":"bp","title":"bq","description":"br","email":"bs","button":"bt"};